import {
  React,
  Component,
  withRouter,
  Link,
} from 'imports/CommonImports';

import {
  AppBar,
  IconButton,
  IconMenu,
  MenuItem,
} from 'material-ui';

import {
  MoreVertIcon,
  MenuIcon
} from 'imports/IconsImports';

class Header extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: this.props.getCookie('user')
    }
  }
  render() {
    const {styles, handleChangeRequestNavDrawer} = this.props;

    const style = {
      appBar: {
        position: 'fixed',
        top: 0,
        overflow: 'hidden',
        maxHeight: 57,
        backgroundColor: '#FFFFFF',
        fontFamily: 'Lato'
      },
      menuButton: {
        marginLeft: 10
      },
      iconsRightContainer: {
        marginLeft: 20,
        alignItems: 'center',
        display: 'flex'
      },
      latoFont: {
        fontFamily: 'Lato'
      }
    };

    return (
        <div>
            <AppBar
              style={{...styles, ...style.appBar}}
              titleStyle={{color:'#000000'}}
              title={
                ""
              }
              iconElementLeft={
                  <IconButton style={style.menuButton} onClick={handleChangeRequestNavDrawer}>
                    <MenuIcon />
                  </IconButton>
              }
              iconElementRight={
                <div style={style.iconsRightContainer}>
                  <h3>{this.state.user.first_name} {this.state.user.last_name}</h3>
                  <IconMenu color={'#000000'}
                            iconButtonElement={
                              <IconButton><MoreVertIcon /></IconButton>
                            }
                            targetOrigin={{horizontal: 'right', vertical: 'top'}}
                            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                  >
                  {this.state.user.position === 'Líder de proyecto' || this.state.user.position === 'Gerente de área' || this.state.user.position === 'Control de gestión'?
                    <div>
                      <MenuItem style={styles.latoFont} primaryText="Mi Perfil" containerElement={<Link to={"/profile/" + this.state.user.id} />}/>
                      <MenuItem style={styles.latoFont} primaryText="Salir" onClick={() => this.logout()}/>
                    </div>
                    :
                    <div>
                      <MenuItem style={styles.latoFont} primaryText="Mi perfil" containerElement={<Link to={"/profile/" + this.state.user.id} />}/>
                      <MenuItem style={styles.latoFont} primaryText="Usuarios" containerElement={<Link to={"/company/" + this.state.user.company_id} />}/>
                      <MenuItem style={styles.latoFont} primaryText="Plazos" containerElement={<Link to={"/portfolio/setup"} />}/>
                      <MenuItem style={styles.latoFont} primaryText="Salir" onClick={() => this.logout()}/>
                    </div>
                  }
                  </IconMenu>
                </div>
              }
            />
          </div>
      );
    }

  logout = () => {
    this.props.removeCookie('token');
    this.props.removeCookie('user');
    this.props.history.push("/");
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/template/Header.js